// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M13.36 11.68C12.91 12.34 12.34 12.91 11.68 13.36',
  'M9.26 14.38C8.85 14.46 8.43 14.5 8 14.5C7.57 14.5 7.15 14.46 6.74 14.38',
  'M4.32 13.36C3.66 12.91 3.09 12.34 2.64 11.68',
  'M1.62 9.26C1.54 8.85 1.5 8.43 1.5 8C1.5 7.57 1.54 7.15 1.62 6.74',
  'M2.64 4.32C3.09 3.66 3.66 3.09 4.32 2.64',
  'M6.74 1.62C7.15 1.54 7.57 1.5 8 1.5C8.43 1.5 8.85 1.54 9.26 1.62',
  'M11.68 2.64C12.34 3.09 12.91 3.66 13.36 4.32',
  'M14.38 6.74C14.46 7.15 14.5 7.57 14.5 8C14.5 8.43 14.46 8.85 14.38 9.26',
];
